// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__349Fp","error":"Group_error__2z7yN"};